import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChange, SimpleChanges, ViewChildren, forwardRef, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DrakeFieldComponent } from 'app/drake-components/drake-field/drake-field.component';
import { ActivatedRoute } from '@angular/router';
import { GridService } from 'app/services/grid.service';
import { throwToolbarMixedModesError } from '@angular/material/toolbar';
import { DrakeSharedService } from 'app/services/drake-shared.service';

@Component({
  selector: 'app-drake-view-wizard',
  templateUrl: './drake-view-wizard.component.html',
  styleUrls: ['./drake-view-wizard.component.scss'],
  standalone: true,
  imports: [CommonModule, InputsModule, forwardRef(() => DrakeFieldComponent)]
})
export class DrakeViewWizardComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() viewConfig: any;
  @Input() baseData: any;
  @Input() readonly: boolean = false;
  @Input() matrix: boolean = false;
  @Input() scope: string;
  @Input() forcedId: string;

  protected id: string;
  private loaded: boolean = false;
  activeStepIndex = 0;

  @Output() public fieldValueChanged: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren(DrakeFieldComponent) drakeFields: QueryList<DrakeFieldComponent>;

  constructor(private activatedRoute: ActivatedRoute, private gridService: GridService, private cdRef: ChangeDetectorRef, private drakeSharedService:DrakeSharedService) {
    this.activatedRoute.params.subscribe(params => {
      if (!this.scope) {
        this.id = decodeURIComponent(params?.['id'] || "#NEWID#");
        this.scope = params?.['scope'];
      }
      else
        this.id = "#NEWID#";
    })
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
  }

  valueChanged(ev) {
    console.log("Value changed drake view");
    this.fieldValueChanged.emit(ev)
    if (!this.viewConfig.invalidFields)
      this.viewConfig.invalidFields = [];
    if (ev.isValid)
      this.viewConfig.invalidFields = this.viewConfig.invalidFields.filter(f => f != ev.field);
    else
      this.viewConfig.invalidFields.push(ev.field);
  }

  updateChildren() {
    this.drakeFields.forEach(f => f.loadFields()); // o un metodo che forza il refresh
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("changes view ", changes);
    //console.log("changes view code",  { viewCode: this.viewConfig.viewCode, filter: `{ "_id": "${this.id}" }` });
    if (changes.scope) {
      this.id = "#NEWID#";
    }

    if (this.forcedId)
      this.id = this.forcedId

    if (!this.matrix) {
      this.baseData[this.scope] = this.baseData[this.scope] ?? {};
      this.baseData[this.scope][this.id] = this.baseData[this.scope][this.id] ?? {};

      if (this.id && this.id != "#NEWID#" && this.viewConfig && !this.loaded) {
        this.id = decodeURIComponent(this.id);
        this.gridService.getScopeDataSimple(this.scope, "READ", { viewCode: this.viewConfig.viewCode, filter: `{ "_id": "${this.id}" }` }).subscribe(result => {

          this.loaded = true;
          //console.log("callresult", result);
          if (result.data.length == 1)
            Object.assign(this.baseData[this.scope][this.id], result.data[0]);
          for (let k of Object.keys(this.baseData[this.scope][this.id])) {
            const newKey = k.includes('$') ? k.split('$')[1] : k;
            this.baseData[this.scope][this.id][newKey] = this.baseData[this.scope][this.id][k];
          }
          this.baseData = { ...this.baseData };
          //console.log('basedata after call', this.baseData)
          this.fieldValueChanged.emit({ all: true });

          //Promise.resolve().then(() => this.cdRef.markForCheck());
          //this.updateChildren();
          this.drakeSharedService.baseData$.next(this.baseData)
        })
      }
    }
    else {
      this.scope = Object.keys(this.baseData)[0];
      this.id = Object.keys(this.baseData[this.scope])[0];
    }


  }

get currentField() {
    return this.viewConfig.viewFields[this.activeStepIndex];
  }

  nextStep() {
    if (this.activeStepIndex < this.viewConfig.viewFields.length - 1) {
      this.activeStepIndex++;
    }
  }

  prevStep() {
    if (this.activeStepIndex > 0) {
      this.activeStepIndex--;
    }
  }

  goToStep(index: number) {
    // Opzionale: permetti il salto solo se lo step è già stato visitato o completato
    this.activeStepIndex = index;
  }
}
